module.exports = __webpack_public_path__ + "img/floorTwo.80e9fd0b.png";